import { render } from "./stopcoursemodal.vue?vue&type=template&id=8bd423d6"
import script from "./stopcoursemodal.vue?vue&type=script&lang=js"
export * from "./stopcoursemodal.vue?vue&type=script&lang=js"

import "./stopcoursemodal.vue?vue&type=style&index=0&id=8bd423d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__